import type { PostSource } from '../types';

export const SHARE_SUCCEEDED_TYPE = 'social.post.share.succeeded';
export const SHARE_FAILED_TYPE = 'social.post.share.failed';

type ShareFailedInput = {
  imageUrls?: string[];
  caption?: string;
  source?: PostSource;
};

type ProviderMessageError = {
  kind: 'provider_message';
  errorCode: 'InstagramInvalidMediaError' | 'InstagramCarouselItemsFailedError';
  providerMessage: string;
};

type ProviderCodeError = {
  kind: 'provider_code';
  errorCode: 'InstagramContainerProcessingError';
  providerErrorCode?: string | null;
  providerErrorSubcode?: string | null;
};

type GenericError = {
  kind: 'generic';
  errorCode: string;
};

export type ShareError =
  | ProviderMessageError
  | ProviderCodeError
  | GenericError;

export type ShareSucceededPayload = {
  type: typeof SHARE_SUCCEEDED_TYPE;
  date: string;
  network: 'INSTAGRAM';
  source: PostSource;
};

export type ShareFailedPayload = {
  type: typeof SHARE_FAILED_TYPE;
  date: string;
  network: 'INSTAGRAM';
  source: PostSource;
  input?: ShareFailedInput;
  error: ShareError;
};

export type ShareFeedbackPayload = ShareSucceededPayload | ShareFailedPayload;

export function isShareFeedbackPayload(
  data: unknown
): data is ShareFeedbackPayload {
  if (!data || typeof data !== 'object') {
    return false;
  }

  const { type, network } = data as Record<string, unknown>;

  return (
    network === 'INSTAGRAM' &&
    (type === SHARE_SUCCEEDED_TYPE || type === SHARE_FAILED_TYPE)
  );
}
